<template>
  <div >
    <div class="loginDiv">
      <a-row>
        <a-col :span="12">
          <h2>登录</h2>
        </a-col>
        <a-col :span="12" style="text-align: right">
          <span>没有账号？</span><router-link to="/user/register">去注册</router-link>
        </a-col>
      </a-row>
      <a-row>
        <a-input size="large" placeholder="账号" autocomplete="true" v-model="userData.username"></a-input>
      </a-row>
      <a-row>
        <a-input
          size="large"
          type="password"
          autocomplete="true"
          @keyup="isSubmit($event)"
          placeholder="密码"
          v-model="userData.password"></a-input>
      </a-row>
      <a-row>
        <sliderValidate ref="sliderValidate" :status.sync="validate_status"></sliderValidate>
      </a-row>
      <a-row>
        <!--<a-col :span="12">-->
        <!--<a-checkbox @change="onChangeC" :defaultChecked="true"/> 记住账号-->
        <!--</a-col>-->
        <a-col :span="24" style="text-align: right">
          <router-link to="/user/repassword">修改/找回密码</router-link>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-button type="primary" size="large" style="float: right" @click="submitData">提交</a-button>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
  // import Config from "../../utils/config";
  // import UserRouteTool from "../../utils/userRouteTool";
  import { mapActions } from 'vuex'
  import { timeFix } from '@/utils/util'
  import sliderValidate from '@/components/SliderValidate/sliderValidate.vue'
  import { encryption } from '@/utils/encryption'
  export default {
    name: 'Login',
    components: {sliderValidate},
    data() {
      return {
        userData:{
          username:'',
          password:''
        },
        isHis:true,
        validate_status:false
      }
    },
    created() {
      // location.href = Config.parameter.publicLoginUrl;
    },
    watch: {

    },
    async mounted() {
      localStorage.setItem('breadcrumb','登录')
      localStorage.setItem('pageTitle','登录')
      // this.$store.commit("setting/setConfig", Config);
      // this.$request.configUserObj(this);
      var res = await this.sendStatus().catch(res =>{
        console.log(res,'error')
      })
      console.log(res,'123')
    },
    computed: {},
    methods: {
      ...mapActions(['Login', 'Logout']),
      onChangeC(e){
        this.isHis = e.target.checked
      },
      sendStatus(subjectId,status,duration){
        return new Promise(function(resolve,reject){
          reject('ok')
        })
      },
      isSubmit(event){
        if (event.keyCode==13){
          this.submitData()
        }
      },
      submitData  () {
        if(!this.userData.username||!this.userData.password){
          this.$notification['error']({
            message: '提示',
            description: '用户名或密码不为空',
            duration: 2
          })
          return
        }
        if(!this.validate_status){
          this.$notification['error']({
            message: '提示',
            description: '请滑动图形码',
            duration: 2
          })
          return
        }
        const password = encryption(this.userData.password)

        const params = {
          username: this.userData.username,
          password
        }
        this.Login(params)
          .then((res) => {
            if (res.code==1) {
              this.$router.push({name: 'index'})
              // if (this.isHis){
              //   localStorage.setItem("username",this.userData.username)
              //   localStorage.setItem("password",this.userData.password)
              // }else{
              //   localStorage.removeItem("username")
              //   localStorage.removeItem("password")
              // }
              // 延迟 1 秒显示欢迎信息
              // setTimeout(() => {
              //   this.$notification.success({
              //     message: '欢迎',
              //     description: `${timeFix()}，欢迎回来`
              //   })
              // }, 1000)
            }
          })
          .catch(err => {
            console.log(err)
            // this.$notification['error']({
            //   message: '错误',
            //   description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
            //   duration: 4
            // })
          })
          .finally(() => {

          })
      },
    }
  }
</script>

<style lang="less" scoped>
  .label-right{
    padding-right: 20px;
    color:rgba(0,0,0,.85);
    margin-top: 5px;
  }
  .loginDiv{
    width: 400px;
    padding: 20px;
    margin: 20px auto;
    border: 1px solid #efefef;
    background: #fff;
    box-shadow: 2px 2px 6px #dedede;
  }
  .ant-row{
    margin-top: 20px;
  }
  .select{
    width:100%;
  }
  h2{
    margin-bottom: 0;
  }
</style>